import { saveAs } from "file-saver";

import { privateAPI } from "@/shared/lib";

interface DownloadPdfParams {
  url: string;
  filename: string;
}

export const downloadPdf = async ({ url, filename }: DownloadPdfParams) => {
  const response = await privateAPI.get(url, { responseType: "blob" });

  const blob = new Blob([response.data], { type: "application/pdf" });

  return saveAs(blob, filename);
};
